import { motion } from "motion/react"
import ServiceCard from "./ServiceCard"

interface ServiceItem {
  key: string
  title: string
  description: string
}

interface ServicesProps {
  section_title: string
  section_title_highlight: string
  items: ServiceItem[]
}

export default function Services({
  section_title,
  section_title_highlight,
  items,
}: ServicesProps) {
  return (
    <section id="services" className="py-24 bg-[#0a0a0f] relative scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {section_title}{" "}
            <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
              {section_title_highlight}
            </span>
          </h2>
          <div className="w-20 h-px bg-gradient-to-r from-violet-500 to-cyan-500 mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, index) => (
            <ServiceCard
              key={item.key}
              serviceKey={item.key}
              title={item.title}
              description={item.description}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
